"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveLozenge = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var _Core_1 = require("../../_Core");
var Icon_1 = require("../../Icons/Icon/Icon");
var Localization_1 = require("../../Localization");
var Theme_1 = require("../../Theme");
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 24px;\n    padding: 0 ", ";\n    display:inline-block;\n    border-radius: 14px;\n    ", ";\n    line-height: 24px;\n    text-align:center;\n    font-size: 11px;\n    vertical-align: middle;\n\n    svg {\n        vertical-align: middle;\n    }\n"], ["\n    height: 24px;\n    padding: 0 ", ";\n    display:inline-block;\n    border-radius: 14px;\n    ", ";\n    line-height: 24px;\n    text-align:center;\n    font-size: 11px;\n    vertical-align: middle;\n\n    svg {\n        vertical-align: middle;\n    }\n"])), Theme_1.PixelUnit(1), Theme_1.Color.Green.Dark);
var Caption = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: ", ";\n"], ["\n    margin: ", ";\n"])), Theme_1.PixelUnit(1));
var ActiveLozenge = /** @class */ (function (_super) {
    __extends(ActiveLozenge, _super);
    function ActiveLozenge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActiveLozenge.prototype.render = function () {
        return (React.createElement(Container, null,
            React.createElement(Icon_1.Icon, { Icon: _Core_1.Icons.Tick, Width: "20px", Height: "20px" }),
            React.createElement(Caption, null, Localization_1.strings.Label_Active)));
    };
    return ActiveLozenge;
}(React.Component));
exports.ActiveLozenge = ActiveLozenge;
var templateObject_1, templateObject_2;
